import { RootState } from '../../../types.ts';
import { propertyDataAdapter } from '../../propertyDataAdapter.ts';

export const {
  selectEntities: selectPropertyDataEntities,
  selectAll: selectAllPropertyData,
  selectById: selectPropertyDataById,
} = propertyDataAdapter.getSelectors((state: RootState) => state.propertyData);
